<template>
  <div style="text-align: center;">
    <div v-if="!hasError">
      <van-col :span="24" style="text-align: center;">
        订单信息
      </van-col>
      <base-input v-model="currSellOrder.order_date" label="订单时间" readonly />
      <base-input v-model="currSellOrder.code" label="订单号" readonly />
      <base-input-number v-model="currSellOrder.receivable_amount" label="订单金额" readonly />
      <base-input v-model="currSellOrder.orderer" label="订货人" readonly />
      <base-input v-model="currSellOrder.orderer_phone" label="订货人电话" readonly />
      <base-input v-model="currSellOrder.delivery_time" label="送货时间" readonly />
      <base-input v-model="currSellOrder.receiver" label="收货人" readonly />
      <base-input v-model="currSellOrder.receiver_phone" label="收货人电话" readonly />
      <base-textarea v-model="currSellOrder.receiver_addr" label="收货人地址" readonly />
      <van-col v-if="hasArrived" span="17" style="font-size: 15px; font-weight: bold; color: #13ce66;">
        您当前查看的订单已经送达！
      </van-col>
      <van-col v-else span="17" style="font-size: 15px; font-weight: bold; color: #ff4949;">
        注意：拍照时请确保图片拍摄清晰！
      </van-col>
      <van-col :span="7" style="text-align: center;">
        <base-button :disabled="!canUpload" @click="openLocation">{{ hasArrived ? '查看上报位置' : '查看当前位置' }}</base-button>
      </van-col>
      <van-col :span="24">
        <van-progress
          v-if="uploading"
          :percentage="uploadingPercentage"
          :pivot-text="uploadingMsg"
          color="#13ce66"
        />
        <van-steps :active="3">
          <van-step>开始拍照</van-step>
          <van-step>等待上传</van-step>
          <van-step>上传完成</van-step>
        </van-steps>
        <van-uploader accept="*" v-model="fileList" :max-count="1" upload-text="请选择文件" :disabled="!canUpload"
                      :deletable="false" multiple :after-read="afterRead" :before-delete="beforeDelete" />
      </van-col>
    </div>
    <div v-else>
      <span style="font-size: 16px; font-weight: bold; color: #ff4949;">{{ errorMsg }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { arrivedSellOrder, getSellOrderList } from '@/api/sell/order'
import { wxJsConfig } from '@/api/commons'
export default {
  name: "DeliveryArrived",
  data() {
    return {
      uploading: false,
      uploadingMsg: '',
      uploadingPercentage: 0,
      canUpload: false,

      fileOrd: 1,
      fileList: [],
      uploadData: {
        main_id: 0,
        longitude: 0,
        latitude: 0
      },
      hasArrived: false,
      hasError: false,
      errorMsg: '',
      currSellOrder: {}
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  async mounted() {
    this.uploadData.main_id = parseInt(this.$route.query.id)
    if (this.uploadData.main_id) {
      const sellOrderResp = await getSellOrderList({ id: this.uploadData.main_id })
      const sellOrderRows = sellOrderResp.rows || []
      if (sellOrderRows.length > 0) {
        this.currSellOrder = sellOrderRows[0]
        if (this.currSellOrder.status >= this.CONST.SELL_ORDER_STATUS.find(status => status.name === '订单送达').id) {
          this.uploadData.longitude = this.currSellOrder.arrived.longitude
          this.uploadData.latitude = this.currSellOrder.arrived.latitude
          if (this.currSellOrder.arrived.picture) {
            this.fileList.push({
              url: `${this.BACKEND_API}/${this.currSellOrder.arrived.picture}?token=${this.token}`,
              status: 'done'
            })
          }
          this.hasArrived = true
        }
      } else {
        this.hasError = true
        this.errorMsg = '参数错误，获取订单信息失败'
        this.alert(this.errorMsg)
      }
      const config = {
        timestamp: Date.now(),
        nonceStr: 'esap',
        jsurl: window.location.href,
        jsapp: this.CONST.AGENT_MAP[this.$route.path]
      }
      const resp = await wxJsConfig(config)
      if (resp.obj && resp.obj.appId && resp.obj.signature) {
        wx.config({
          beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: resp.obj.appId, // 必填，企业微信的corpID
          timestamp: config.timestamp, // 必填，生成签名的时间戳
          nonceStr: config.nonceStr, // 必填，生成签名的随机串
          signature: resp.obj.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: ['getLocation', 'openLocation'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        })
        wx.ready(() => {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          if (!this.hasArrived) {
            wx.getLocation({
              type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: (res) => {
                this.uploadData.longitude = res.longitude // 经度，浮点数，范围为180 ~ -180
                this.uploadData.latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
                this.canUpload = true
                this.success('获取位置信息成功')
              }
            })
          }
        })
        wx.error(res => {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          console.error(res)
          this.hasError = true
          this.errorMsg = '初始化企业微信接口错误'
          this.alert(this.errorMsg)
        })
      } else {
        this.hasError = true
        this.errorMsg = '初始化企业微信接口错误'
        this.alert(this.errorMsg)
      }
    } else {
      this.hasError = true
      this.errorMsg = '参数错误，请您从企业微信端进入'
      this.alert(this.errorMsg)
    }
  },
  methods: {
    openLocation() {
      wx.openLocation({
        longitude: this.uploadData.longitude, // 经度，浮点数，范围为180 ~ -180
        latitude: this.uploadData.latitude, // 纬度，浮点数，范围为90 ~ -90
        name: this.hasArrived ? '上报位置' : '当前位置', // 位置名
        address: this.hasArrived ? '上报位置' : '当前位置', // 地址详情说明
        scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为16
      })
    },
    beforeDelete(file) {
      return new Promise((resolve, reject) => {
        reject()
        // deleteImage({
        //   id: file.obj.id,
        //   open_id: this.uploadData.open_id
        // }).then(resp => {
        //   if (resp.success) {
        //     resolve()
        //     Toast(resp.msg)
        //   } else {
        //     reject()
        //   }
        // });
      })
    },
    async afterRead(file) {
      this.canUpload = false
      this.uploading = true
      this.uploadingPercentage = 0
      let files = []
      if (file instanceof Array) {
        files = file
      } else {
        files.push(file)
      }
      try {
        for (let i = 0; i < files.length; i++) {
          this.uploadingPercentage = parseFloat(parseFloat((i + 1) / files.length * 100).toFixed(2))
          this.uploadingMsg = ` ${i + 1}/${ files.length }`

          let originFile = files[i]
          let suffixPos = originFile.file.name.lastIndexOf('.')
          let suffixName = originFile.file.name.substring(suffixPos + 1)
          let isImg = this.CONST.IMAGE_TYPES.find(type => type === suffixName) != null
          if (isImg) {
            let rst = await this.lrz(originFile.file)
            await this.uploadFile(originFile, rst.formData, this.fileOrd++)
          } else {
            let formData = new FormData()
            formData.append('file', originFile.file)
            await this.uploadFile(originFile, formData, this.fileOrd++)
          }
        }
        this.canUpload = false // 订单送达后不能再上传图片
        this.hasArrived = true
        this.alert('订单送达成功')
      } catch (error) {
        this.canUpload = true
        this.error(error)
        this.alert(error)
      }
      this.uploadingPercentage = 100
      this.uploading = false
    },
    uploadFile(originFile, formData, ord) {
      return new Promise((resolve, reject) => {
        for(const key in this.uploadData) {
          formData.append(key, this.uploadData[key])
        }
        arrivedSellOrder(formData).then(resp => {
          if (resp.success) {
            console.log('文件上传成功 ord: ', ord)
            this.success(resp.msg)
            resolve()
          } else {
            console.error('文件上传失败 ord: ', ord)
            this.delFile(originFile)
            reject(resp.msg)
          }
        }).catch(error => {
          console.error('文件上传失败 ord: ', ord)
          this.delFile(originFile)
          reject(error.message)
        })
      })
    },
    delFile(file) {
      let index = this.fileList.indexOf(file);
      if (index !== -1) {
        this.fileList.splice(index, 1);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/delivery/arrived.vue